import { MITee } from '@app/evaluation-core/types'
import React, { useCallback, useEffect } from 'react'
import { ButtonContainer } from '../../atoms/ContinueButton/styled'
import * as S from './styled'
import styled from 'styled-components'
import theme from '@app/ui/theme'
import ColorInput from './CustomColorInput'

type TeeColorPickerProps = {
  tees?: MITee[]
  onSave?: (teeColors: string[], teeNames: string[]) => void
}
const Container = styled.div`
  display: flex;
  gap: 8px;
`

const NameInput = styled.input.attrs({ type: 'text' })`
  width: 90%;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  text-align: center;
  font-size: ${theme.fontSize[1]}px;
`

const TeeColorPicker = ({ tees = [], onSave }: TeeColorPickerProps) => {
  const [teesState, setTeesState] = React.useState<MITee[]>([])

  useEffect(() => {
    setTeesState(
      tees.map((tee) => ({
        ...tee,
        color: tee.color?.startsWith('#') ? tee.color : `#${tee.color}`,
      }))
    )
  }, [tees])
  const handleColorChange = useCallback(
    (color: string, index: number) => {
      const newTees = [...teesState]
      newTees[index] = {
        ...newTees[index],
        color: color.startsWith('#') ? color : `#${color}`,
      }
      setTeesState(newTees)
    },
    [teesState]
  )

  const handleNameChange = useCallback(
    (name: string, index: number) => {
      const newTees = [...teesState]
      newTees[index] = {
        ...newTees[index],
        name,
      }
      setTeesState(newTees)
    },
    [teesState]
  )

  const handleSubmit = () => {
    const teeColors = teesState.reduce(
      (acc: string[], tee) => (tee.color ? [...acc, tee.color] : acc),
      []
    )
    const teeNames = teesState.reduce(
      (acc: string[], tee) => (tee.name ? [...acc, tee.name] : acc),
      []
    )
    onSave?.(teeColors, teeNames)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        paddingTop: '8px',
      }}
    >
      <Container>
        {teesState.map((tee, index) => (
          <S.TeeCard key={index}>
            <S.TeeCardColor>
              <ColorInput
                label={`Color for ${tee.name}`}
                value={tee.color}
                onChange={(color) => handleColorChange(color, index)}
              />
            </S.TeeCardColor>
            <S.TeeCardName>
              <NameInput
                value={tee.name}
                onChange={(e) => handleNameChange(e.target.value, index)}
                aria-label={`${tee.name} name editor`}
              />
            </S.TeeCardName>
          </S.TeeCard>
        ))}
      </Container>
      <ButtonContainer style={{ marginLeft: 'auto' }} onClick={handleSubmit}>
        <S.ButtonText>SAVE TEE INFO</S.ButtonText>
      </ButtonContainer>
    </div>
  )
}

export default TeeColorPicker
